module.exports = __webpack_public_path__ + "img/resistant.52378089.svg";